import { render, staticRenderFns } from "./AddNewCompanyNow.vue?vue&type=template&id=be0d2b18&scoped=true"
import script from "./AddNewCompanyNow.vue?vue&type=script&lang=js"
export * from "./AddNewCompanyNow.vue?vue&type=script&lang=js"
import style0 from "./AddNewCompanyNow.vue?vue&type=style&index=0&id=be0d2b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0d2b18",
  null
  
)

export default component.exports